import React, { useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {Modal,Fade,Backdrop} from '@mui/material';
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import ZoomInMapIcon from "@mui/icons-material/ZoomInMap";
import Stack from "@mui/material/Stack";

import {
  getTicketComments,
} from "../../actions/LimsAdminActions";
import "./index.sass";

let width = window.innerWidth;
let isMobile = width <= 500;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: isMobile ? "400px" : "1200px", zIndex:1,
  },
}));

type ModalProps = {
  openModal: boolean;
  setopenModal: Function;
  bookingId: any;
  loading: boolean;
  ticketComments: any;
  getTicketComments: any;
};

const CommentsModal: React.FC<ModalProps> = ({
  openModal,
  setopenModal,
  bookingId,
  loading,
  ticketComments,
  getTicketComments,
}) => {
  const classes = useStyles();
  const [maxHeight, setMaxHeight] = React.useState<any>(300);

  const handleClose = () => {
    setopenModal(false);
  };

useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (bookingId !== "" && openModal) {
      getTicketComments(`${bookingId}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);



  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <div className={classes.paper}>
            <h6
              style={{
                marginBottom: "10px",
                textAlign: "center",
                borderBottom: "1px solid rgba(0,0,0,0.5)",
              }}
              id="transition-modal-title"
            >
              Comment History
              {Number(maxHeight) === Number(300) ? (
                <Stack
                  direction="row"
                  spacing={2}
                  style={{ display: "block", textAlign: "end" }}
                >
                  <ZoomOutMapIcon
                    fontSize="large"
                    onClick={() =>
                      Number(maxHeight) === Number(600)
                        ? setMaxHeight(Number(600))
                        : setMaxHeight(Number(600))
                    }
                  />
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  spacing={2}
                  style={{ display: "block", textAlign: "end" }}
                >
                  <ZoomInMapIcon
                    fontSize="large"
                    onClick={() =>
                      Number(maxHeight) === Number(300)
                        ? setMaxHeight(Number(300))
                        : setMaxHeight(Number(300))
                    }
                  />
                </Stack>
              )}
            </h6>
            <div
              id="transition-modal-description"
              className="modal-form-wrapper"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: `${maxHeight}px`,
              }}
            >
              <div
                className="comment-history"
                style={{ height: `${maxHeight}px` }}
              >
                {loading
                  ? "Please Wait"
                  : Object.keys(ticketComments).length > 0
                  ? ticketComments.map((comment: any) => (
                      <p>
                        {comment?.created_at.substring(0, 10)} :{" "}
                        {comment?.created_at.substring(11, 19)} :{" "}
                        {comment?.comments} : {comment?.disposition}:{" "}
                      </p>
                    ))
                  : ""}
              </div>
             
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  ticketComments: state.LimsAdminReducer.ticketComments,
  loading: state.LimsAdminReducer.loading,
});

export default connect(mapStateToProps, {
  getTicketComments,
})(CommentsModal);
